import { useMemo } from 'react';

import { useSession } from 'src/services/pagerduty/session';

import pd from 'src/lib/api/pagerduty-ui/pagerduty';
import { getQueryParams } from 'src/lib/history';
import { usePromise } from 'src/lib/hooks';

let incidentPromise = null;

export const useIncident = () => {
  const { loggedIn, loading: sessionLoading } = useSession();
  const { incident_id: incidentId } = getQueryParams();

  const { data, loading, error } = usePromise(() => {
    if (!loggedIn && !sessionLoading) {
      return Promise.reject('Please login first.');
    } else if (!incidentId) {
      return Promise.reject('Incident ID required.');
    } else if (loggedIn) {
      if (!incidentPromise) {
        incidentPromise = pd.getIncident(incidentId, { 'include[]': 'first_trigger_log_entries' });
      }
      return incidentPromise;
    }
    return new Promise(() => {});
  }, [loggedIn, sessionLoading, incidentId]);

  return useMemo(() => ({
    incident: data,
    loading,
    error
  }), [data, loading, error]);
};

